import React, { useState, useEffect } from "react";
import { DonutChart } from "bizcharts";
import FormatNumber from "../../helper/FormatNumber";
const colorPalette = {
  APPROVED: '#5CBC8E', 
  DECLINED: '#EB636C',
};


const renderLegendTable = (data, colorMap) => {
    return (
      <table style={{ width: '100%', textAlign: 'left', borderCollapse: 'collapse', marginTop: 20 , border: '1px solid #f0f0f0'}}>
       
        <tbody>
          {data.map((item, index) => (
            <tr key={"fraudchecks_"+index} style={{ border: '1px solid #f0f0f0'}}>
              <td style={{ padding: '4px 8px' }}>
                <span style={{ backgroundColor: colorMap[item.response] ? colorMap[item.response] : '', display: 'inline-block', width: 12, height: 12, borderRadius: '50%' }}></span>
              </td>
              <td style={{ padding: '4px 8px'}}>{item.response}</td>
              <td style={{ padding: '4px 8px'}}>{item.value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };
  
  const FraudCheckPieChart = (props) => {
    const { t, data } = props;
    const [colorMap, setColorMap] = useState({});

  useEffect(() => {
    const newColorMap = {};

    data.forEach((d) => {
      if (!newColorMap[d.response]) {
        newColorMap[d.response] = colorPalette[d.response];
      }
    });
    setColorMap(newColorMap);
  }, [data]);
       return (
        <div>
        <DonutChart
            data={data ? data : []}
            forceFit
            height={250}
            radius={0.8}
            padding="auto"
            angleField="value"
            colorField="response"
            animation={false}
            color={(item)=>  colorMap[item.response]}           
            legend={{
                layout:"vertical",
                position: "bottom",
                visible:false,
                           
            }}
			statistic={{
				title: {
					customHtml: () => data.length ? t("contents.dashboard.total") : t("contents.dashboard.total") + " 0"
                },
                content: {
					formatter: (angleField, colorField) => {
                        let summary = 0;
                        colorField.forEach(item => {
                          summary += item.value
                        });
                        return summary > 0 ? String(FormatNumber(summary)).replace('.00','') : '0';
                    }
                }
			}}
        />
         {renderLegendTable(data, colorMap)}
        </div>
    );
};

export default FraudCheckPieChart;
